import MegaparkLogo from "../assets/images/megapark.png";
export type LegalBlock =
  | { type: "p"; text: string }
  | { type: "ul"; items: string[] }
  | { type: "ol"; items: string[] }
  | { type: "subtitle"; text: string }
  | { type: "note"; text: string };

export type LegalSection = {
  id: string;          // anchor
  title: string;       // bölüm başlığı
  blocks: LegalBlock[]; // bölüm içerikleri
};

export type LegalContent = {
  pageTitle: string;
  hospitalName: string;
  hero?: {
    rightLogoUrl?: string;   // sağ üstte logo
    kicker?: string;         // üst küçük başlık
  };
  sections: LegalSection[];
};

export const kvkkContent: LegalContent = {
  pageTitle: "Kişisel Verilerim İşlenmesine İlişkin Aydınlatma Metni",
  hospitalName: "Özel Megapark Hastanesi",
  hero: {
    kicker: "ÖZEL MEGAPARK HASTANESİ",
    rightLogoUrl: MegaparkLogo,
  },
  sections: [
    {
      id: "giris",
      title: "Giriş",
      blocks: [
        {
          type: "p",
          text:
            "Özel Megapark Hastanesi (kısaca “Hastane“)’nin bağlı olduğu tüzel kişilik MARSAM Özel Sağlık Hiz. İnş. Turizm San. ve Tic. AŞ tarafından 6698 sayılı Kişisel Verilerin Korunması Kanunu (kısaca “Kanun”) ve ilgili mevzuat kapsamında Veri Sorumlusu sıfatıyla, kişisel verileriniz, aşağıda açıklanan çerçevede ve 3359 sayılı Sağlık Hizmetleri Temel Kanunu, 663 sayılı Sağlık Bakanlığı ve Bağlı Kuruluşlarının Teşkilat ve Görevleri Hakkında Kanun Hükmünde Kararname, Özel Hastaneler Yönetmeliği ve Sağlık Bakanlığı düzenlemeleri ve sair mevzuata uygun olarak işlenebilecektir.",
        },
        {
          type: "p",
          text:
            "Hastalarımızın bizimle paylaştığı her türlü kişisel verinin veri güvenliğini, hasta mahremiyetine özen göstererek ve kişisel verilerine uygun düşen her türlü teknik ve idari tedbiri alarak muhafaza etmekteyiz.",
        },
      ],
    },

    {
      id: "islenen-kisisel-veriler",
      title: "1. İşlenen Kişisel Veriler",
      blocks: [
        {
          type: "p",
          text:
            "Kişisel verileriniz Hastane tarafından, kamu sağlığının korunması, koruyucu hekimlik, tıbbî teşhis, tedavi ve bakım hizmetlerinin yürütülmesi, sağlık hizmetleri ile finansmanının planlanması ve yönetimi amaçlarıyla ve Hastane’nin faaliyet konularına uygun düşecek şekilde; sözlü, yazılı, görsel ya da elektronik ortamda, çağrı merkezi, internet sitesi, sözlü, yazılı ve benzeri kanallar aracılığıyla elde edilmektedir. Sağlık verileriniz başta olmak üzere özel nitelikli kişisel verileriniz ve genel nitelikli kişisel verileriniz, Hastane tarafından aşağıda yer alanlar dâhil ve bunlarla sınırlı olmaksızın bu maddede belirtilen amaçlar ile bağlantılı, sınırlı ve ölçülü şekilde işlenebilmektedir.",
        },
        { type: "subtitle", text: "Kimlik Bilgileriniz" },
        {
          type: "p",
          text:
            "Adınız, soyadınız, T.C. Kimlik numaranız, pasaport numaranız veya geçici TC Kimlik numaranız, doğum yeri ve tarihiniz, medeni haliniz, cinsiyetiniz, sigorta veya hasta protokol numaranız ve sizi tanımlayabileceğimiz diğer kimlik verileriniz.",
        },
        { type: "subtitle", text: "İletişim Bilgileriniz" },
        {
          type: "p",
          text:
            "Adresiniz, telefon numaranız, elektronik posta adresiniz ve sair iletişim verileriniz, müşteri temsilcileri ya da hasta hizmetleri tarafından çağrı merkezi standartları gereği tutulan sesli görüşme kayıtlarınız ile elektronik posta, mektup veya sair vasıtalar aracılığı ile tarafımızla iletişime geçtiğinizde elde edilen kişisel verileriniz.",
        },
        { type: "subtitle", text: "Muhasebesel Bilgileriniz" },
        {
          type: "p",
          text:
            "Banka hesap numaranız, IBAN numaranız, kredi kartı bilginiz, faturalama bilgileriniz gibi finansal verileriniz.",
        },
        { type: "subtitle", text: "Sağlık Bilgileriniz" },
        {
          type: "p",
          text:
            "Hasta dosya no, takip no, laboratuvar sonuçlarınız, test sonuçlarınız, muayene verileriniz, randevu bilgileriniz, check-up bilgileriniz, reçete bilgileriniz, anamnez bilgileriniz, tetkik ve tahlil sonuçlarınız, epikriz bilgileriniz dahil ancak bunlarla sınırlı olmaksızın tıbbî teşhis, tedavi ve bakım hizmetlerinin yürütülmesi sırasında veya bunların bir sonucu olarak elde edilen her türlü sağlık ve cinsel hayata ilişkin kişisel verileriniz.",
        },
        { type: "subtitle", text: "Sair Bilgileriniz" },
        {
          type: "ul",
          items: [
            "Sağlık hizmetlerinin finansmanı ve planlaması amacıyla özel sağlık sigortasına ilişkin verileriniz ve Sosyal Güvenlik Kurumu verileriniz.",
            "Hastanemizi ziyaret etmeniz halinde güvenlik ve denetim amaçlı tutulmakta olan kamera kayıtları görüntüleriniz.",
            "www.megaparkhastanesi.com internet sitesine gönderdiğiniz veya girdiğiniz sağlık verileriniz ve sair kişisel verileriniz.",
            "Hastaneye fiziki veya elektronik ortamda iş başvurusunda bulunmanız halinde bu hususta temin edilen özgeçmiş dâhil sair kişisel verileriniz ile hastane çalışanı ya da çalışan yakını olmanız halinde iş akdiniz ve işyeri özlük dosyanız ile ilgili her türlü kişisel verileriniz.",
            "Hastane’de yasal zorunlu stajyer olmanız halinde hizmet akdiniz ve stajyer dosyanız ile ilgili her türlü kişisel verileriniz.",
            "Hastane’yle başta satın/hizmet alma olmak üzere akdi ilişkiye girmeniz sebebiyle ürün/hizmet satan kişi/eğitmen olmanız halinde akdiniz ile ilgili başta her türlü kişisel verileriniz.",
          ],
        },
      ],
    },

    {
      id: "isleme-amaclari",
      title: "2. Kişisel Veri İşleme Amaçları",
      blocks: [
        {
          type: "p",
          text:
            "Hastane’miz tarafından kişisel verileriniz aşağıdaki amaçlar dahilinde işlenebilecektir:",
        },
        {
          type: "ul",
          items: [
            "3359 sayılı Sağlık Hizmetleri Temel Kanunu, 663 sayılı Sağlık Bakanlığı ve Bağlı Kuruluşlarının Teşkilat ve Görevleri Hakkında Kanun Hükmünde Kararname, 6698 sayılı Kişisel Verilerin Korunması Kanunu, 5510 sayılı Sosyal Sigortalar ve Genel Sağlık Sigortası Kanunu, Özel Hastaneler Yönetmeliği, Kişisel Sağlık Verilerinin İşlenmesi ve Mahremiyetinin Sağlanması Hakkında Yönetmelik (kısaca “Yönetmelik”) ve ilgili diğer mevzuatta yer alan hukuki yükümlülüklerimizi yerine getirme.",
            "Kişisel verilerinizin başkaları tarafından ele geçirilmesini engelleyebilmek adına kimlik tespiti ve doğrulama.",
            "Kamu sağlığının korunması, koruyucu hekimlik, tıbbî teşhis, tedavi ve bakım hizmetlerinin yürütülmesi, sağlık hizmetleri ile finansmanının planlanması ve yönetimi.",
            "Size özel ilaç ve/veya tıbbi malzeme ve/veya cihaz temini.",
            "Randevu almanız halinde randevu hakkında sizi haberdar edebilme, bilgi sağlama ve/veya randevu hatırlatma.",
            "Risk yönetimi ve kalite geliştirme aktivitelerinin yerine getirilmesi.",
            "Yasal ve düzenleyici gereksinimlerin yerine getirilmesi.",
            "Mevzuat uyarınca Sağlık Bakanlığı ve diğer kamu kurum ve kuruluşları ile edinilen bilgileri paylaşma ve yanıt verme.",
            "Hastane ile anlaşmalı olan kurum/kuruluşlarla hak sahipliğinizi sorgulama veya bu kurumlarla size sunulan sağlık hizmetlerine ilişkin finansal mutabakat sağlanması.",
            "Sağlık hizmetlerinin finansmanı kapsamında özel sigorta şirketleri başta olmak üzere anlaşmalı kurum/kuruluşlarca talep edilen bilgileri paylaşma ve kimlik doğrulama.",
            "Sunduğumuz hizmetler karşılığında fatura tanzim etme.",
            "Hastane sistem ve uygulamalarının veri güvenliği kapsamında tüm gerekli teknik ve idari tedbirlerin alınması.",
            "Size sunduğumuz sağlık hizmetlerinin geliştirilmesi ve iyileştirilmesi amacıyla sağlık hizmetleri kullanımınızı analiz etme ve sağlık verilerinizi saklama, hizmetlerimize ilişkin soru veya şikayetlerinize yanıt verme.",
            "Düzenleyici ve denetleyici kurumlarla, resmi mercilerin talep ve denetimleri doğrultusunda gerekli bilgilerin temini.",
            "İlgili mevzuat gereği saklanması gereken sağlık verilerinize ilişkin bilgileri muhafaza etme.",
            "İç politika ve prensiplerine uyum sağlama.",
            "Sağlık hizmetleri almanızı takiben hasta memnuniyetinin ölçülmesi ve hasta memnuniyetinin artırılması.",
            "Sizlere özel tanıtım ve bilgilendirme faaliyetlerinin yürütülmesi ve faydalanmanızın sağlanması, hizmetlerimize ilişkin olarak bilgilendirme amacıyla sizinle iletişime geçilmesi.",
            "Bunlarla sınırlı olmaksızın, tıbbî teşhis, tedavi ve bakım hizmetlerinin yürütülmesi, geliştirilmesi, sağlık hizmetleri ile finansmanının planlanması ve yönetimi, hasta memnuniyetinin arttırılması, araştırılması ve bağlı nedenler.",
          ],
        },
        {
          type: "p",
          text:
            "İlgili mevzuat uyarınca elde edilen ve işlenen kişisel verileriniz, Hastane’mize ait fiziki arşivler ve/veya bilişim sistemlerine nakledilerek, hem dijital ortamda hem de fiziki ortamda muhafaza altında tutulabilecektir.",
        },
      ],
    },

    {
      id: "aktarim",
      title: "3. Kişisel Verilerin Aktarılması",
      blocks: [
        {
          type: "p",
          text:
            "Kişisel verilerinizi, uygun güvenlik düzeyini temin etmeye yönelik gerekli her türlü teknik ve idari tedbirlerin alınmasını sağlayarak, işbu metnin 2. maddesinde yer alan amaçlar doğrultusunda; Kanun ve ilgili diğer mevzuat hükümlerinin izin verdiği iştirak şirketleri, özel sigorta şirketleri, Sağlık Bakanlığı ve bağlı alt birimleri, Sosyal Güvenlik Kurumu, Emniyet Genel Müdürlüğü ve sair kolluk kuvvetleri, Nüfus Genel Müdürlüğü, Türkiye Eczacılar Birliği, Mahkemeler ve her türlü yargı makamı, yetki vermiş olduğunuz temsilcileriniz, avukatlar, düzenleyici ve denetleyici kurumlar, resmi merciler dâhil olmak üzere sağlık hizmetlerini yukarıda belirtilen amaçlarla geliştirmek veya yürütmek üzere işbirliği yaptığımız iş ortaklarımız ve diğer üçüncü kişilere aktarabiliriz.",
        },
      ],
    },

    {
      id: "toplama-hukuki-sebep",
      title: "4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebepleri",
      blocks: [
        {
          type: "p",
          text:
            "Kişisel verileriniz, her türlü sözlü, yazılı, görsel ya da elektronik ortamda, yukarıda yer verilen amaçlar ve sağlık hizmetlerinin belirlenen yasal çerçevede verilebilmesi ve bu kapsamda Hastanemizin akdi ve kanuni yükümlülüklerini tam ve gereği gibi ifa edebilmesi için elde edilir.",
        },
        {
          type: "ul",
          items: [
            "6698 sayılı Kişisel Verilerin Korunması Kanunu,",
            "3359 sayılı Sağlık Hizmetleri Temel Kanunu,",
            "663 sayılı Sağlık Bakanlığı ve Bağlı Kuruluşlarının Teşkilat ve Görevleri Hakkında Kanun Hükmünde Kararname,",
            "Özel Hastaneler Yönetmeliği,",
            "Kişisel Sağlık Verilerinin İşlenmesi ve Mahremiyetinin Korunması Yönetmeliği, Sağlık Bakanlığı düzenlemeleri ve sair mevzuat hükümleri.",
          ],
        },
        {
          type: "p",
          text:
            "Ayrıca, Kanun’un 6. maddesi 3. fıkrasında da belirtildiği üzere sağlık ve cinsel hayata ilişkin kişisel veriler ise ancak kamu sağlığının korunması, koruyucu hekimlik, tıbbî teşhis, tedavi ve bakım hizmetlerinin yürütülmesi, sağlık hizmetleri ile finansmanının planlanması ve yönetimi amacıyla, sır saklama yükümlülüğü altında bulunan kişiler veya yetkili kurum ve kuruluşlar tarafından ilgilinin açık rızası aranmaksızın işlenebilir.",
        },
      ],
    },

    {
      id: "haklar",
      title: "5. Kişisel Verilerin Korunmasına Yönelik Haklarınız",
      blocks: [
        {
          type: "p",
          text:
            "Kişisel veri sahibi olarak, işlenen kişisel verilerinizle ilgili mevzuat uyarınca kişisel veri işlenip işlenmediğini öğrenme; kişisel verileri işlenmişse buna ilişkin bilgi talep etme; kişisel sağlık verilerine erişim ve bu verileri isteme; kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme; kişisel verilerin aktarıldığı üçüncü kişileri bilme; kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme; kişisel verilerin silinmesini veya yok edilmesini isteme; kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesine ve/veya kişisel verilerin silinmesini veya yok edilmesine ilişkin işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme; işlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme, kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini tarafımızdan talep etme haklarına sahip olduğunuzu bilgilerinize sunarız.",
        },
        {
          type: "p",
          text:
            "Mezkûr haklarınızdan birini ya da birkaçını kullanmanız halinde ilgili bilgi tarafınıza, açık ve anlaşılabilir bir şekilde yazılı olarak ya da elektronik ortamda, tarafınızca sağlanan iletişim bilgileri yoluyla, bildirilir.",
        },
        {
          type: "p",
          text:
            "Kişisel veri işlenip işlenmediğini öğrenme hakkınızı, kişisel verileri işlenmişse buna ilişkin bilgi talep etme hakkınızı; kişisel sağlık verilerine erişim ve bu verileri isteme hakkınızı, kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme hakkınızı ya da kişisel verilerin aktarıldığı üçüncü kişileri bilme hakkınızı kullanmanız halinde ilgili bilgi tarafınıza, açık ve anlaşılabilir bir şekilde yazılı olarak ya da elektronik ortamda, tarafınızca sağlanan iletişim bilgileri yoluyla bildirilecektir. Hastane, talebin niteliğine göre talebi en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi hâlinde, Hastane tarafından Kişisel Verileri Koruma Kurulunca belirlenen tarifedeki ücret alınacaktır.",
        },
      ],
    },

    {
      id: "veri-guvenligi",
      title: "6. Veri Güvenliği",
      blocks: [
        {
          type: "p",
          text:
            "Hastane, kişisel verilerinizi bilgi güvenliği standartları ve prosedürleri gereğince alınması gereken tüm teknik ve idari güvenlik kontrollerine tam uygunlukla korumaktadır. Söz konusu güvenlik tedbirleri, teknolojik imkânlar da göz önünde bulundurularak muhtemel riske uygun bir düzeyde sağlanmaktadır.",
        },
        {
          type: "p",
          text:
            "Mezkûr haklarınızdan birini ya da birkaçını kullanmanız halinde ilgili bilgi tarafınıza, açık ve anlaşılabilir bir şekilde yazılı olarak ya da elektronik ortamda, tarafınızca sağlanan iletişim bilgileri yoluyla, bildirilir.",
        },
        {
          type: "p",
          text:
            "Kişisel veri işlenip işlenmediğini öğrenme hakkınızı, kişisel verileri işlenmişse buna ilişkin bilgi talep etme hakkınızı; kişisel sağlık verilerine erişim ve bu verileri isteme hakkınızı, kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme hakkınızı ya da kişisel verilerin aktarıldığı üçüncü kişileri bilme hakkınızı kullanmanız halinde ilgili bilgi tarafınıza, açık ve anlaşılabilir bir şekilde yazılı olarak ya da elektronik ortamda, tarafınızca sağlanan iletişim bilgileri yoluyla bildirilecektir. Hastane, talebin niteliğine göre talebi en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi hâlinde, Hastane tarafından Kişisel Verileri Koruma Kurulunca belirlenen tarifedeki ücret alınacaktır.",
        },
      ],
    },

    {
      id: "kamera-aydinlatma",
      title: "7. Kamera Görüntü Kaydı Aydınlatma Metni",
      blocks: [
        {
          type: "p",
          text:
            "Hastanemize ait kamera görüntü kaydı aydınlatma metnini, idari ofisimizde yer alan “Özel Megapark Hastanesi Hizmet Binası İçerisinde Yer Alan Güvenlik Kameraları Hakkında Aydınlatma Metni”ne bakıp inceleyebilir ve bu hususta bilgi edinebilirsiniz.",
        },
      ],
    },

    {
      id: "cerez-politikasi",
      title: "8. Çerez Politikası",
      blocks: [
        {
          type: "p",
          text:
            "Hastanemizin çerez politikasını, internet sitemizde yer alan “Çerez Politikası”na bakıp inceleyebilir ve bu hususta bilgi edinebilirsiniz.",
        },
      ],
    },

    {
      id: "sikayet-basvuru",
      title: "9. Şikayet ve Başvuru",
      blocks: [
        {
          type: "p",
          text:
            "Kanun kapsamındaki taleplerinizi, internet sitemizde yer alan “Kişisel Veri Başvuru Formu” ve genel açıklamalarına bakarak gerçekleştirebilirsiniz.",
        },
      ],
    },
  ],
};
